import * as Scrivito from "scrivito";

export const HeroSliderPanel = Scrivito.connect(({ panel, slider }) => {
  const destination = panel.get("destination");
  const buttonColor = slider.get("background")
    ? "bg-transparent-black"
    : "bg-yellow";

  return (
    <div className="hero-slider-item container">
      <div className="hero-slider-item-subheadline">
        {panel.get("headline")}
      </div>
      <div className="hero-slider-item-headline">
        <h3>{panel.get("description") || "Keine Beschreibung angegeben"}</h3>
        <div>
          {destination && (
            <Scrivito.LinkTag to={destination} className={`btn ${buttonColor}`}>
              {destination.title() || "read more"}
            </Scrivito.LinkTag>
          )}
        </div>
      </div>
      <div className="hero-slider-item-date">{panel.get("date")}</div>
    </div>
  );
});
